export enum Errors {
  manualExtraVerificationFallback = 'manualExtraVerificationFallback',
  extraVerificationFlowRequired = 'extraVerificationFlowRequired',
  extraVerificationRequired = 'extraVerificationRequired',
  ssnRequired = 'ssnRequired',
  ageRestriction = 'ageRestriction',
  errorEmail = 'errorEmail',
  addressIsPOB = 'addressIsPOB',
}

export default Errors;
